export const getReviewEntryCurrencySymbol = (currencyId: string, locale?: string): string => {
  try {
    const parts = new Intl.NumberFormat(locale?.replace('_', '-'), {
      currency: currencyId,
      style: 'currency',
    }).formatToParts(0)

    return parts.find((part) => part.type === 'currency')?.value ?? currencyId
  } catch {
    return currencyId
  }
}
